<!-- Note:
        Steps to add new `Template` for `drop-down toggler` & `drop-down item`:
            - 1. Add new template in `cs-drop-down-item-templates.component.html` or `cs-drop-down-toggler-templates.component.html`
            - 2. Add respective `template-ref` into `view-child` on respective `.ts` file
            - 3. Add a new template type into `cs-components.types.ts` on respective type `TCsDdTogglerTemplateType` or `TCsDdItemTemplateType`
            - 4. Register the added template with new type in `cs-drop-down.service.ts`
            - 5. Use respective template whenever using `app-cs-drop-down` with the help of `Template type` along with `drop-down config`
        -->

<!-- Todo: Need to work on container positioning, while using dropdown with container -->

<ng-container *ngIf="!ddConfig.isHide">
    <div dropdown
         class="btn-group"
         #dropdown="bs-dropdown"
         [autoClose]="false"
         (onShown)="onDdShown(dropdown)"
         (onHidden)="onDdHidden()"
         [dropup]="ddConfig.isDropUp"
         [container]="ddConfig.ddContainer || ''">

        <div dropdownToggle
             class="btn dropdown-toggle">
            <ng-container
                [ngTemplateOutlet]="ddConfig.ddTogglerConfig.templateType.toUpperCase() === 'CUSTOM' ? ddConfig.ddTogglerConfig.customTemplateRef : togglersHolder[ddConfig.ddTogglerConfig.templateType]"
                [ngTemplateOutletContext]="{ togglerConfig: ddConfig.ddTogglerConfig, menuConfig: ddConfig.ddMenuConfig }">
            </ng-container>
        </div>

        <div *dropdownMenu
             class="dropdown-menu {{ddConfig.ddTogglerConfig.ddPlacement || 'right'}}"
             [ngStyle]="ddConfig.ddMenuConfig['customStyle']"
             [ngClass]="{
             'with-search-bar': ddConfig.ddMenuConfig.isSearchBar,
             'solid-toggler': ddConfig.ddTogglerConfig.togglerType === 'SOLID',
             'transparent-toggler': ddConfig.ddTogglerConfig.togglerType === 'TRANSPARENT'}">

            <div *ngIf="ddConfig?.ddMenuConfig?.isSearchBar" class="search-panel">
                <app-cs-search-bar
                    (onItemSearch)="filterOrResetDdItems($event)"
                    [searchText]="ddSearchText"
                    [isHideClearBtn]="true">
                </app-cs-search-bar>
            </div>

            <div class="menu-content-wrapper" [ngStyle]="ddConfig.ddMenuConfig['menuContentWrapperCustomStyle']">
                <div class="group-List"
                     *ngIf="ddConfig.ddMenuConfig.isGroupItem; else nonGroupItem"
                     [ngStyle]="{'grid-template-columns': getDdMenuGridColumnSetup(ddConfig.ddMenuConfig.gridColumns)}">
                    <ng-container *ngFor="let group of ddConfig.ddMenuConfig.groupItems">
                        <div class="dd-group" *ngIf="group && !group.isHide">
                            <div class="dd-group-title">
                                <span>{{group.title | capitalize}}</span>
                            </div>
                            <ng-container [ngTemplateOutlet]="ddItem"
                                          [ngTemplateOutletContext]="{$implicit: group.items}">
                            </ng-container>
                        </div>
                    </ng-container>
                </div>

                <div id="picker-holder"></div>
            </div>

            <ng-template #nonGroupItem>
                <div class="dd-item-list"
                     [ngStyle]="{'grid-template-columns': getDdMenuGridColumnSetup(ddConfig.ddMenuConfig.gridColumns)}">
                    <ng-container [ngTemplateOutlet]="ddItem"
                                  [ngTemplateOutletContext]="{$implicit: ddConfig.ddMenuConfig.items}">
                    </ng-container>
                </div>
            </ng-template>
        </div>
    </div>

    <ng-template #ddItem let-itemsList>
        <ng-container *ngIf="itemsList && filteredItems('ENABLED').length; else noDataTemplate">
            <ng-container *ngFor="let item of itemsList">
                <!--                <div class="dd-item-wrapper" *ngIf="item && !item['isHide']">-->
                <div class="dd-item-wrapper"
                     *ngIf="item && !item['isHide']"
                     [ngClass]="{
                        'selected-item': item['isSelected'],
                        'multi-choice': item['isMultiChoiceItem']
                     }">
                    <ng-container *ngIf="item['isPicker']; else itemTemplate">
                        <div
                            class="picker"
                            *ngIf="item['pickerType'] === 'DATE'"
                            bsDatepicker
                            #dp="bsDatepicker"
                            [bsConfig]="item['pickerConfig']['_config']"
                            [placement]="item['pickerConfig']['placement']"
                            [container]="item['pickerConfig']['container'] || '#picker-holder'"
                            (onShown)="onDpShown(dp)"
                            (bsValueChange)="onPickerClick(item['pickerType'], item, $event)">
                            <ng-container [ngTemplateOutlet]="itemTemplate"></ng-container>
                        </div>

                        <div
                            class="picker"
                            *ngIf="item['pickerType'] === 'DATE_RANGE'"
                            bsDaterangepicker
                            #drp="bsDaterangepicker"
                            [bsConfig]="item['pickerConfig']['_config']"
                            [placement]="item['pickerConfig']['placement']"
                            [container]="item['pickerConfig']['container'] || '#picker-holder'"
                            (onShown)="onDpShown(drp)"
                            (bsValueChange)="onPickerClick(item['pickerType'], item, $event)">
                            <ng-container [ngTemplateOutlet]="itemTemplate"></ng-container>
                        </div>
                    </ng-container>

                    <ng-template #itemTemplate>
                        <ng-container
                            [ngTemplateOutlet]="item['itemTemplateType'].toUpperCase() === 'CUSTOM'? item['itemCustomTemplateRef'] : itemsHolder[item['itemTemplateType']]"
                            [ngTemplateOutletContext]="{ $implicit: item }">
                        </ng-container>
                    </ng-template>
                </div>
            </ng-container>
        </ng-container>

        <ng-template #noDataTemplate>
            <div class="no-data-found-wrapper p-16-pxl">
                <app-no-data-found></app-no-data-found>
            </div>
        </ng-template>

    </ng-template>
</ng-container>

<app-cs-drop-down-toggler-templates #togglerTemplates></app-cs-drop-down-toggler-templates>

<app-cs-drop-down-item-templates
    #itemTemplates
    (onItemClick)="onDdItemClick($event)"
    (onItemElementClick)="onDdItemElementClick($event)">
</app-cs-drop-down-item-templates>

